<html>  
    <!----------------------------------------------------------------------->
    <body class="dx-viewport">

        <dx-box
            direction="col"
            width="100%"
            [height]="formheight"
        > 
                <!----------------------------------------------------------------------->
                <dxi-item
                    [ratio]="0.60"
                    class="rectangle"
                >
                    <!----------------------------------------------------------------------->
                    <dx-select-box
                        #faqcategory
                        id="faqcategory"
                        [elementAttr]="{ class: 'selectbox1' }"
                        [dataSource]="subscriptionfaqcategory"
                        placeholder="FAQ Categories"
                        [showClearButton]="true"
                        [inputAttr]="{ autocomplete: 'chrome-off' }"

                        displayExpr="category"
                        valueExpr ="id"
                    
                        height="35px"
                        width="270px"

                        (onItemClick)="selectfaqtype( $event )" 
                    >

                    </dx-select-box>
                    
    
                </dxi-item> 
                <!----------------------------------------------------------------------->
                <dxi-item
                    [ratio]="0.08"
                > 
                </dxi-item>  
                <!-----------------------------------------------------------------------> 
                <dxi-item
                    [ratio]="10"
                    class="rectangle"
                >

                    <dx-data-grid 
                        #gridfaq
                        id="gridfaq"
                        keyExpr="id"
                        [dataSource]="subscriptionfaqdetailprofile"    
                        [allowColumnReordering]="false"
                        [allowColumnResizing]="true"
                        [showRowLines]="true"
                        [showColumnLines]="true"
                        [showBorders]="true"
                        [repaintChangesOnly]="true"
                        [focusedRowEnabled]="true"
                        [autoNavigateToFocusedRow]="true"

                        [disabled]="faqstatus"
                
                        width="100%"
                        height="100%"
            
                        (onInitNewRow)="initinsertfaqdoc($event)"

                        (onRowInserted)="insertfaqdoc($event)"
                        (onRowUpdated)="insertfaqdoc($event)"

                        (onEditingStart)="editfaqdoc($event)"

                    >

                        <dxo-editing 
                            mode="popup"                            
                            [allowUpdating]="true"
                            [allowDeleting]="true"
                            [allowAdding]="true"
                            [useIcons]="true">

                           
                            <dxo-popup
                                title="FAQ Details"
                                [showTitle]="true"
                                [width]="600"
                                [height]="525"
                                [position]= "{
                                                of: '#gridfaq',
                                                my: 'left',
                                                at: 'top',
                                                offset: '-300 300'
                                            }"
                                >

                            </dxo-popup>
                                <!----------------------------------------------------------------------->
                            
                                <dxo-form>
                            
                                    <dxi-item itemType="group" [colCount]="2" [colSpan]="2">

                                        <dxi-item 
                                            dataField="notestatus"
                                            editorType="dxCheckBox"
                                            [editorOptions]="{ width: 200, inputAttr: { autocomplete: 'chrome-off'}  }"
                                            cssClass="statusLabel"
                                        >
                                            <dxo-label
                                                location="left"
                                                alignment="left"> <!-- or "left" | "center" -->
                                            </dxo-label>

                                        </dxi-item>

                                        <dxi-item 
                                            dataField="noteid"
                                            [editorOptions]="{ width: 200, disabled: faqnew, inputAttr: { autocomplete: 'chrome-off'}  }"
                                        >
                                            <dxo-label
                                                location="left"
                                                 alignment="left"> <!-- or "left" | "center" -->
                                            </dxo-label>
                                        </dxi-item>

                                        <dxi-item 
                                            dataField="title"
                                            [colSpan]="2"
                                            [editorOptions]="{ width: 550,  height: 30, inputAttr: { autocomplete: 'chrome-off'}  }"
                                        >
                                            <dxo-label
                                                location="top"
                                                alignment="left"> <!-- or "left" | "center" -->
                                            </dxo-label>

                                        </dxi-item>

                                        <dxi-item
                                            dataField="note"
                                            editorType="dxTextArea"
                                            [colSpan]="2"
                                            [editorOptions]="{  width: 550, height: 280, inputAttr: { autocomplete: 'chrome-off'} }"
                                        >

                                            <dxo-label
                                                location="top"
                                                alignment="left"> <!-- or "left" | "center" -->
                                            </dxo-label>

                                        </dxi-item>

                                    </dxi-item>

                                </dxo-form>    
                                <!----------------------------------------------------------------------->

                        </dxo-editing>

                        <dxo-selection
                            mode="single">
                        </dxo-selection>

                        <dxi-column
                            dataField="id"
                            caption="NoteId"
                            [allowEditing]="false" 
                            [allowSorting]="false"
                            [visible]="true"
                            width="5%"

                            cssClass="grdcelltextvertalign"
                        >                        
                        </dxi-column>  

                        <dxi-column
                            dataField="notestatus"
                            dataType="boolean"
                            caption="Open"
                            [allowEditing]="true" 
                            [allowSorting]="false"
                            [visible]="true"
                            width="5%"

                            cssClass="grdcelltextvertalign"
                        >
                        </dxi-column>  

                        <dxi-column
                            dataField="noteid"
                            caption="SortId"
                            [allowEditing]="true" 
                            [allowSorting]="false"
                            [visible]="true"
                            width="5%"

                            cssClass="grdcelltextvertalign"
                        >

                            <dxi-validation-rule 
                                type="required"
                                message="Please enter FAQ NoteId">
                            </dxi-validation-rule>

                        </dxi-column>  
                
                        <dxi-column
                            dataField="title"
                            caption="Title"
                            [allowEditing]="true" 
                            [allowSorting]="false"
                            [visible]="true"
                            width="45%"

                            cssClass="grdcelltextvertalign"
                        >

                            <dxi-validation-rule 
                                type="required"
                                message="Please enter FAQ Title">
                            </dxi-validation-rule>

                        </dxi-column>
                        
                        <dxi-column
                            dataField="note"
                            caption="Note"
                            [allowEditing]="true" 
                            [allowSorting]="false"
                            [visible]="true"

                            cellTemplate="faqNoteTemplate"

                            width="50%"
                        >

                            <dxi-validation-rule 
                                type="required"
                                message="Please enter FAQ Notes">
                            </dxi-validation-rule>

                        </dxi-column>  

                            <div *dxTemplate="let d of 'faqNoteTemplate'">

                                <dx-text-area
                                    [height]="90"
                                    [disabled]="true"
                                    
                                    [(value)]="d.data.note">
                            </dx-text-area>
                        
                        </div>
                        <!----------------------------------------------------------------------->

                    </dx-data-grid>
                
                </dxi-item>
                <!----------------------------------------------------------------------->
 
        </dx-box>
    
    
    </body>
    <!----------------------------------------------------------------------->
</html>


